module.exports = __webpack_public_path__ + "static/media/buildings.8db52233.svg";